export default "__VITE_ASSET__3dde6130__"